export const IB_ACCOUNT_RULES_FETCH = 'IB_ACCOUNT_RULES_FETCH';
export const IB_ACCOUNT_RULES_IS_FETCING = 'IB_ACCOUNT_RULES_IS_FETCHING';
export const IB_ACCOUNT_RULES_API = `ibs/accountrules`;
export const IB_ACCOUNT_RULE_EDIT = 'IB_ACCOUNT_RULE_EDIT';
export const IB_ACCOUNT_RULE_SAVE = 'IB_ACCOUNT_RULE_SAVE';
export const IB_ACCOUNT_RULE_FILTER = 'IB_ACCOUNT_RULE_FILTER';
export const SET_IB_ACCOUNT_RULE_PROFILE = 'SET_IB_ACCOUNT_RULE_PROFILE';
export const SET_IB_ACCOUNT_RULE_IB = 'SET_IB_ACCOUNT_RULE_IB';


// WEBPACK FOOTER //
// ./src/constants/ibAccountRules.js